<H1>Your Token is Deleted</H1>
<div class="container">
  Thank You For Using Our Application.
</div>